export default __webpack_public_path__ + "static/media/256.591ccfff.png";